// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TextWithInfo-modulewrapper3Nw","infoText":"TextWithInfo-moduleinfoText36g","infoIcon":"TextWithInfo-moduleinfoIconEsO"};